module.exports = __webpack_public_path__ + "media/images/emoticons/gemini-ed2f3db11d1c058f9f515ecf3d86b8cd.gif";